<template>
  <div class="container">
    <!-- 主体内容 -->
    <Boyo-Content ref="BoyoContent" :loading="tableDataCusLoading">
      <BoyoButton :buttonList="buttonList"
                  @handClick="handClick">
      </BoyoButton>
      <div style="float:left;margin-bottom:10px;font-size:14px">
        <!-- <span>销售类型：</span>
        <el-select size="small" v-model="formDate.saleType" filterable placeholder="请选择客户" @change="changeSaleType" disabled>
          <el-option
            v-for="item in listTypeInfo.saleType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
        <span>价格本编号：</span>
        <el-input
          size='small'
          style="width:140px"
          v-model="formDate.billNo"
          :disabled="true">
        </el-input>
        <span>价格本标题：</span>
        <el-input
          size='small'
          style="width:140px"
          v-model="formDate.billTitle"
          :disabled="true">
        </el-input>
        <span>客户：</span>
        <el-select size="small" v-model="formDate.partnerId" filterable clearable placeholder="请选择客户" @change="changePartnerId">
          <el-option
            v-for="item in listTypeInfo.partnerId"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <!-- <span>销售项目：</span>
        <el-select size="small" v-model="formDate.projectId" filterable placeholder="请选择客户销售项目" :disabled="formDate.saleType?false:true" @change="changeProjectId">
          <el-option
            v-for="item in listTypeInfo.projectId"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
      </div>
      <el-table :data="tableInfo2.data"
              border
              max-height="600px"
              style="width: 100%"
              v-loading='tableDataCusLoading'
              :header-cell-style="{background:'#f7f8f9',color:'#3C3C3C',padding:'4px 0',border:'1px solid #e5e7e8' }"
              :cell-style="{padding:'2px'}"
              :span-method="objectSpanMethod"
              @row-click="handleCellChange">
        <el-table-column prop="areaName"
                        label="区域"
                        width="80px" align="center">
        </el-table-column>
        <el-table-column prop="partnerName"
                        label="客户"
                        width="140px" align="center">
        </el-table-column>
        <template v-for="item of tableInfo2.fieldList">
          <!-- <el-table-column v-if="item.show"
                          :key="item.value"
                          :label="item.label"
                          :prop="item.value"
                          :width="item.width"
                          :align="item.align||'center'"> -->
            <el-table-column v-for="(child,index) of item.basePriceAreaList"
                              :key="index"
                              :label="child.label"
                              align="center">
              <!-- <template slot-scope="scope">
                <el-input v-model="scope.row.basePriceAreaList[index].areaPrice">
                </el-input>
              </template> -->
              <!-- <el-table-column v-for="(tew,index2) of child.childs"
                                :key="index2"
                                align="center"> -->
              <!-- <template v-for="(tew,index2) of child.childs"> -->
                <el-table-column label="区域价格" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.basePriceAreaList[index].childs[0].areaPrice" disabled>
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="partnerAddPrice"
                                  label="客户加价" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.basePriceAreaList[index].childs[1].partnerAddPrice" @input="partnerAddPriceInput(scope.row.basePriceAreaList,index)">
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="partnerPrice"
                                  label="客户价格" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.basePriceAreaList[index].childs[2].partnerPrice" disabled>
                      </el-input>
                    </template>
                  </el-table-column>
              <!-- </template> -->
              <!-- <template slot-scope="scope">
                <el-input v-model="scope.row.basePriceAreaList[index].areaPrice">
                </el-input>
              </template> -->
            </el-table-column>
          <!-- </el-table-column> -->
        </template>
        <!-- <el-table-column v-for="item of tableInfo2.fieldList"
                        :prop="item.prop"
                        :key="item.value"
                        :label="item.label"
                        width="150" align="center">
          <el-table-column prop="areaPrice"
                          label="区域价格" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.basePriceAreaList[add2].areaPrice">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="partnerAddPrice"
                          label="客户加价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.basePriceAreaList[add2].partnerAddPrice">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="partnerPrice"
                          label="客户价格" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.basePriceAreaList[add2].partnerPrice">
              </el-input>
            </template>
          </el-table-column>
        </el-table-column> -->
      </el-table>
    </Boyo-Content>
  </div>
</template>

<script>
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
export default {
  name: 'BasicPriceAddCus',
  components: {
    BoyoContent,
    BoyoButton
  },
  props: {},
  data () {
    let nowDate = new Date() 
    var year = nowDate.getFullYear();
    var mother = nowDate.getMonth() > 8 ? (nowDate.getMonth() + 1) : ('0' + (nowDate.getMonth() + 1));
    var day = (nowDate.getDate()) > 9 ? (nowDate.getDate()) : ('0' + (nowDate.getDate()));
    var hour = nowDate.getHours() > 9 ? (nowDate.getHours()) : ('0' + nowDate.getHours());
    var minute = nowDate.getMinutes() > 9 ? (nowDate.getMinutes()) : ('0' + nowDate.getMinutes());
    var second = nowDate.getSeconds() > 9 ? (nowDate.getSeconds()) : ('0' + nowDate.getSeconds());
    var newDay = year + '-' + mother + '-'+ day +' '+ hour + ':' + minute + ':' + second
    return {
      newDay,
      search: {},
      add2:0,
      MaterialDate:[],//物料数据
      tableDataCus:[],
      tableDataCusLoading:false,//客户价格本加载状态
      addOrUp:false,
      formDate:{
        tissueName:JSON.parse(localStorage.BasicPriceDate).tissueName,
        tissueId:JSON.parse(localStorage.BasicPriceDate).tissueId,
        billNo:JSON.parse(localStorage.BasicPriceDate).billNo,
        billTitle:JSON.parse(localStorage.BasicPriceDate).billTitle,
        billStartTime:JSON.parse(localStorage.BasicPriceDate).billStartTime,
        partnerId:'',//用于批量保存客户价格本
        partnerName:'',
        partnerCode:'',
        saleType:0,
        projectId:'',
        projectCode:'',
        projectName:'',
      },
      // 表格头部按钮相关
      buttonList: {
        // 左按钮
        left: [
          { icon: "el-icon-back", style: "background:#fff;color:#666;border:1px solid #666;margin-right:10px", desc: "返回", event: "back" },
          { icon: "el-icon-refresh-left", style: "background:#fff;color:#666;border:1px solid #666;margin-right:10px", desc: "重置", event: "refresh" },
          { icon: 'el-icon-bottom', style: 'background:#fff;color:#666;border:1px solid #666', desc: '导入最新生效客户价格', event: 'dropDown' },
          { icon: 'el-icon-edit', style: 'background:#34afbb', desc: '保存客户价格本', event: 'create' },
          // { icon: 'el-icon-delete', style: 'background:#e26774', desc: '删除', event: 'delete',show:false },
        ]
      },
      //主体内容是否加载
      listTypeInfo:{
        validStatus:[{value:0,label:'未审核'},{value:1,label:'已审核'}],
        cancleStatus:[{value:0,label:'否'},{value:1,label:'作废'}],
        tissueId:[],
        baseStatus:[{value:0,label:'否'},{value:1,label:'是'}],//是否基价
        bagFlag:[{value:0,label:'散装'},{value:1,label:'袋装'}],//袋装标识
        partnerId:[],//客户
        saleType:[{value:0,label:'区域'},{value:1,label:'项目'}],//销售类型
        projectId:[],//客户项目
        unitName:[],//单位
      },
      //表格相关
      tableInfo2: {
        data: [],//数据
        fieldList: [
          // { value: 'areaName', label: '区域', show: true, dropdown: true },
          { value: 'materialName', label: '客户价格本', show: true, dropdown: true,basePriceAreaList:[] },
        ]
      },
    }
  },
  mounted () {
    if (localStorage.loginTissueId) {
      this.listTypeInfo.tissueId = [{value:parseInt(localStorage.loginTissueId),label:localStorage.loginTissueName}]
    } else {
      this.$api.organization.getSysTissuePage({pageNum: 1, pageSize: 999}).then(res => {//组织
          if(res.code == 0) {
              let list3 = res.data.list
              for( let i in list3 ) {
                  this.listTypeInfo.tissueId.push({value: parseInt(list3[i].id), label: list3[i].tissueName})
              }
          }
      })
    }
    // this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,categoryCode:'Unit'}).then(res => {//枚举（单位）
    //     if(res.code == 0) {
    //         let list1 = res.data.list
    //         for( let i in list1 ) {
    //             this.listTypeInfo.unitName.push({value: list1[i].enumName, label: list1[i].enumName})
    //         }
    //     }
    // })
    this.$api.Customer.getBasePartnerPage({pageNum: 1,pageSize: 999,partnerType:0,forbidStatus:0}).then(res => {//客户
      if (res.code == 0) {
        this.listTypeInfo.partnerId = []
        for(let i in res.data.list){
          this.listTypeInfo.partnerId.push({ value: res.data.list[i].partnerId, label: res.data.list[i].partnerName, partnerCode: res.data.list[i].partnerCode})
        }
      }
    })
    this.$api.Material.getBaseMaterialPage({pageNum: 1,pageSize: 999}).then(res => {//物料
      if (res.code == 0) {
        for(let i in res.data.list){
          if (res.data.list[i].materialType == 1||res.data.list[i].materialType == 2) {
              this.tableInfo2.fieldList[0].basePriceAreaList.push({ value: res.data.list[i].materialId, label: res.data.list[i].materialName,prop:'materialId'+Number(res.data.list[i].materialId)})
              this.MaterialDate.push({ value: res.data.list[i].materialId, label: res.data.list[i].materialName,prop:'materialId'+Number(res.data.list[i].materialId)
              ,basePriceAreaList:[{areaPrice:'',partnerAddPrice:'',partnerPrice:''}],materialId: res.data.list[i].materialId,materialNo: res.data.list[i].materialNo,materialName: res.data.list[i].materialName,taxRate:res.data.list[i].taxRate
              ,materialSpec:res.data.list[i].materialSpec,baseStatus:Number(res.data.list[i].baseStatus),taxRate:res.data.list[i].taxRate,bagFlag:Number(res.data.list[i].bagFlag),bagSzName:res.data.list[i].bagSzName,bagBzwName:res.data.list[i].bagBzwName,unitName:res.data.list[i].unitName}
            )
          }
        }
      }
    })
    this.getInfo()
  },
  methods: {
    handleCellChange (row, column, event) {
      this.add2 = row.addIndex;
    },
    handleDelete (index, rows) {
      this.tableDataCus.splice(index, 1);
    },
    partnerAddPriceInput(row,i){//客户加价修改事件
      // console.log(row[i])
      row[i].partnerAddPrice = row[i].childs[1].partnerAddPrice
      row[i].partnerPrice = Number(row[i].areaPrice) + Number(row[i].partnerAddPrice)
      row[i].childs[2].partnerPrice = row[i].partnerPrice
    },
    changeSaleType(val){//选择销售类型事件
      this.formDate.projectId = ''
      this.formDate.partnerId = ''
      for (let ins of this.tableDataCus) {
        ins.partnerAddPrice = ''
        ins.partnerPrice = ''
      }
      for (let inde2 of this.tableInfo2.data) {
        inde2.basePriceAreaList.forEach((itm1 ,index1)=>{
          itm1.partnerAddPrice = ''
          itm1.partnerPrice = itm1.areaPrice
          itm1.childs[1].partnerAddPrice = ''
          itm1.childs[2].partnerPrice = itm1.areaPrice
        })
      }
    },
    changePartnerId(val){//选择客户事件
      this.getInfo()
    },
    changeProjectId(val){//选择项目事件
      for (let inds of this.listTypeInfo.projectId) {
        if (val == inds.value) {
          this.formDate.projectName = inds.label
          this.formDate.projectCode= inds.projectCode
          for (let inde2 of this.tableInfo2.data) {
            inde2.basePriceAreaList.forEach((itm1 ,index1)=>{
              if (itm1.materialId == inds.materialId) {
                // itm1.partnerAddPrice = Number(inds.partnerAddPrice)
                // itm1.partnerPrice = Number(itm1.areaPrice)+Number(itm1.partnerAddPrice)
                // itm1.childs[1].partnerAddPrice = Number(inds.partnerAddPrice)
                // itm1.childs[2].partnerPrice =  Number(itm1.areaPrice)+Number(itm1.partnerAddPrice)
                itm1.partnerPrice = Number(itm1.partnerAddPrice)
                itm1.childs[2].partnerPrice = Number(itm1.partnerAddPrice)
              }
            })
          }
          // for (let ins of this.tableDataCus) {
          //   ins.partnerAddPrice = Number(inds.partnerAddPrice)
          //   ins.partnerPrice = Number(ins.areaPrice)+Number(inds.partnerAddPrice)
          // }
        }
      }
    },
    //搜索事件
    getInfo () {//区域物料表和价格本，没价格本就差区域加价表赋值
      for (let j of this.MaterialDate) {
        j.basePriceAreaList = []
      }
      this.tableDataCusLoading = true
      // this.$api.Region.getBaseAreaPage({pageNum:1,pageSize:999}).then(res => {
      this.$api.Customer.getBasePartnerSalesAreaPage({pageNum:1,pageSize:999,tFlag: 0,partnerId:this.formDate.partnerId}).then(res => {
        if (res.code == 0) {
          let arr = []
          this.tableDataCus = []
          for (let inq of res.data.list) {
            for (let jd of this.MaterialDate) {
              jd.basePriceAreaList.push({materialId:jd.materialId,materialName:jd.materialName,materialNo:jd.materialNo,materialSpec:jd.materialSpec,baseStatus:Number(jd.baseStatus),basePrice:'',areaAddPrice:'',areaPrice:'',partnerAddPrice:'',partnerPrice:'',taxRate:jd.taxRate,bagFlag:Number(jd.bagFlag),bagSzName:jd.bagSzName,bagBzwName:jd.bagBzwName,unitName:jd.unitName})
            }
          }
          // partnerId:jd.partnerId,partnerName:jd.partnerName,
          let arr1 = res.data.list
          this.$api.Material.getBaseMaterialPage({pageNum:1,pageSize:9999}).then(res => {
            if (res.code == 0) {
              let arr2 = res.data.list
              for (let index of arr2) {
                if (index.materialType == 1||index.materialType == 2) {
                  arr.push(index)
                }
              }
              let addNum = 0
              for (let index2 of arr1) {
                this.tableDataCus.push({partnerId:index2.partnerId,partnerName:index2.partnerName,areaId:index2.areaId,areaName:index2.areaName,addIndex:addNum,basePriceAreaList:[]})
                for (let index3 of arr) {
                  this.tableDataCus[addNum].basePriceAreaList.push({id:'',partnerId:index2.partnerId,partnerName:index2.partnerName,areaId:index2.areaId,areaName:index2.areaName,materialId:index3.materialId,materialName:index3.materialName,materialNo:index3.materialNo,materialSpec:index3.materialSpec,baseStatus:Number(index3.baseStatus),basePrice:'',areaAddPrice:'',areaPrice:'',partnerAddPrice:'',partnerPrice:'',taxRate:index3
                  .taxRate,unitName:index3.unitName,childs:[
                    {areaPrice:''},
                    {partnerAddPrice:''},
                    {partnerPrice:''}
                  ]})
                }
                addNum++
              }
              // console.log(this.tableDataCus)
              this.tableInfo2.data = this.tableDataCus
              this.tableDatasCus()
              this.buttonList.left[3].desc = '保存客户价格本'
              this.$nextTick(() =>{
                this.$api.Customer.getBasePricePartnerPage({pageNum:1,pageSize:999,saleType:0,partnerId:this.formDate.partnerId,priceBookId:JSON.parse(localStorage.BasicPriceDate).priceBookId}).then(res => {
                  if (res.data.list.length>0) {
                    this.buttonList.left[3].desc = '修改客户价格本'
                    let resDate = res.data.list
                    this.addOrUp = true//该客户已有相应价格本（拿id走修改）
                    this.$api.Region.getBasePriceAreaPage({priceBookId:JSON.parse(localStorage.BasicPriceDate).priceBookId,pageSize:999,pageNum:1}).then(res => {
                      if (res.code == 0) {
                        this.tableDataCusLoading = false
                        for (let inde of res.data.list) {
                          for (let ind of inde.basePriceAreaList) {
                            for (let inde2 of this.tableInfo2.data) {
                              inde2.basePriceAreaList.forEach((itm1 ,index1)=>{
                                if (ind.areaId == itm1.areaId && ind.materialId == itm1.materialId) {
                                  for (const key in ind) {
                                    if (key in itm1) {
                                      // if (key!='id') {
                                        if (key=='basePrice' || key=='areaAddPrice' || key=='areaPrice') {//key=='addPrice' || 
                                          itm1[key] = ind[key] ==0?'':ind[key]
                                          if (key=='areaPrice') {
                                            itm1.childs[0].areaPrice = ind[key] ==0?'':ind[key]
                                            itm1.areaPrice = ind[key] ==0?'':ind[key]
                                            itm1.childs[2].partnerPrice = ind[key] ==0?'':ind[key]
                                            itm1.partnerPrice = ind[key] ==0?'':ind[key]
                                          }
                                        }
                                        // else {
                                        //   itm1[key] = ind[key]
                                        // }
                                        for (let ijnde of resDate) {
                                          if(ijnde.basePricePartnerList){
                                            for (let ijnd of ijnde.basePricePartnerList) {
                                              for (let ijnde2 of this.tableInfo2.data) {
                                                ijnde2.basePriceAreaList.forEach((ijtm1 ,index1)=>{
                                                  if (ijnd.areaId == ijtm1.areaId && ijnd.materialId == ijtm1.materialId && ijnde.partnerId == ijtm1.partnerId) {
                                                    ijtm1.id = ijnd.id
                                                    if (ijnd.basePrice) { // 修改有id有基价
                                                      ijtm1.childs[0].areaPrice = ijnd.areaPrice == 0?'':Number(ijnd.basePrice)+Number(ijnd.areaAddPrice)
                                                      ijtm1.areaPrice = ijnd.areaPrice ==0?'':Number(ijnd.basePrice)+Number(ijnd.areaAddPrice)
                                                      ijtm1.childs[1].partnerAddPrice= ijnd.partnerAddPrice ==0?'':ijnd.partnerAddPrice
                                                      ijtm1.partnerAddPrice= ijnd.partnerAddPrice ==0?'':ijnd.partnerAddPrice
                                                      ijtm1.childs[2].partnerPrice= ijnd.partnerPrice ==0?'':Number(ijtm1.areaPrice)+Number(ijtm1.partnerAddPrice)
                                                      ijtm1.partnerPrice= ijnd.partnerPrice ==0?'':Number(ijtm1.areaPrice)+Number(ijtm1.partnerAddPrice)
                                                    }
                                                  }
                                                })
                                              }
                                            }
                                          }
                                        }
                                      // }
                                    }
                                  }
                                }
                              })
                            }
                          }
                        }
                      } else {
                        this.$message({ message: res.msg, type: 'error' })
                        this.tableDataCusLoading = false
                      }
                    })
                    // this.$api.Region.getBasePriceAreaPage({priceBookId:JSON.parse(localStorage.BasicPriceDate).priceBookId,pageSize:999,pageNum:1}).then(res => {
                    //   if (res.code == 0) {
                    //     for (let inde of res.data.list) {
                    //       for (let ind of inde.basePriceAreaList) {
                    //         for (let inde2 of this.tableInfo2.data) {
                    //           inde2.basePriceAreaList.forEach((itm1 ,index1)=>{
                    //             if (ind.areaId == itm1.areaId && ind.materialId == itm1.materialId) {
                    //               for (const key in ind) {
                    //                 if (key in itm1) {
                    //                   if (key!='id') {
                    //                     if (key=='basePrice' || key=='areaAddPrice' || key=='areaPrice') {//key=='addPrice' || 
                    //                       itm1[key] = ind[key] ==0?'':ind[key]
                    //                       if (key=='areaPrice') {
                    //                         itm1.childs[0].areaPrice = ind[key] ==0?'':ind[key]
                    //                         itm1.areaPrice = ind[key] ==0?'':ind[key]
                    //                         // itm1.childs[2].partnerPrice = ind[key] ==0?'':ind[key]
                    //                         // itm1.partnerPrice = ind[key] ==0?'':ind[key]
                    //                       }
                    //                     } else {
                    //                       itm1[key] = ind[key]
                    //                     }
                    //                   }
                    //                 }
                    //               }
                    //             }
                    //           })
                    //         }
                    //       }
                    //     }
                    //   } else {
                    //     this.$message({ message: res.msg, type: 'error' })
                    //   }
                    // })
                  } else {
                    this.addOrUp = false
                    //查询各个物料区域价格
                    this.$api.Region.getBasePriceAreaPage({priceBookId:JSON.parse(localStorage.BasicPriceDate).priceBookId,pageSize:999,pageNum:1}).then(res => {
                      if (res.code == 0) {
                        this.tableDataCusLoading = false
                        for (let inde of res.data.list) {
                          for (let ind of inde.basePriceAreaList) {
                            for (let inde2 of this.tableInfo2.data) {
                              inde2.basePriceAreaList.forEach((itm1 ,index1)=>{
                                if (ind.areaId == itm1.areaId && ind.materialId == itm1.materialId) {
                                  for (const key in ind) {
                                    if (key in itm1) {
                                      if (key!='id') {
                                        if (key=='basePrice' || key=='areaAddPrice' || key=='areaPrice') {//key=='addPrice' || 
                                          itm1[key] = ind[key] ==0?'':ind[key]
                                          if (key=='areaPrice') {
                                            itm1.childs[0].areaPrice = ind[key] ==0?'':ind[key]
                                            itm1.areaPrice = ind[key] ==0?'':ind[key]
                                            itm1.childs[2].partnerPrice = ind[key] ==0?'':ind[key]
                                            itm1.partnerPrice = ind[key] ==0?'':ind[key]
                                          }
                                        } else {
                                          itm1[key] = ind[key]
                                        }
                                      }
                                    }
                                  }
                                }
                              })
                            }
                          }
                        }
                        this.$nextTick(() =>{
                          this.$api.Customer.getBasePartnerAreaPage({pageNum:1,pageSize:9999,partnerId:this.formDate.partnerId}).then(res => { //查询客户区域加价
                            if (res.code == 0) {
                              if (res.data.list.length>0) {
                                for (let inde1 of res.data.list) {
                                  for (let ind of inde1.basePartnerAreaList) {
                                    for (let inde2 of this.tableInfo2.data) {
                                      inde2.basePriceAreaList.forEach((itm1 ,index1)=>{
                                        if (ind.areaId == itm1.areaId && ind.materialId == itm1.materialId && ind.partnerId == itm1.partnerId) {
                                          for (const key in ind) {
                                            if (key in itm1) {
                                              if (key=='partnerAddPrice') {
                                                itm1[key] = ind[key] ==0?'':ind[key]
                                                itm1.childs[1].partnerAddPrice = ind[key] ==0?'':ind[key]
                                                itm1.partnerPrice = Number(itm1['areaPrice'])+Number(itm1['partnerAddPrice'])
                                                itm1.childs[2].partnerPrice = itm1.partnerPrice
                                              }
                                            }
                                          }
                                        }
                                      })
                                    }
                                  }
                                }
                              }
                            } else {
                              this.$message({ message: res.msg, type: 'error' })
                            }
                          })
                        })
                      } else {
                        this.$message({ message: res.msg, type: 'error' })
                        this.tableDataCusLoading = false
                      }
                    })
                  }
                })
              })
            } else {
              this.$message({ message: res.msg, type: 'error' })
              this.tableDataCusLoading = false
            }
          })
        } else {
          this.$message({ message: res.msg, type: 'error' })
          this.tableDataCusLoading = false
        }
      })
    },
    tableDatasCus () {//用于一样的数据列合并
      let _rowspan = 1;
      let _colspan = 1;
      let label = null;
      let row = null;
      this.tableInfo2.data.forEach((item, index) => {
        if (item.partnerId !== label) {
          row = item;
          label = item.partnerId;
          _rowspan = 1;
          _colspan = 1;
          item._rowspan = _rowspan;
          item._colspan = _colspan;
        } else {
          _rowspan++;
          _colspan = 1;
          row._rowspan = _rowspan;
          row._colspan = _colspan;
          item._colspan = 0;
          item._rowspan = 0;
        }
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      //columnIndex == 1合并列
      if (columnIndex == 1) {
        return {
          colspan: row._colspan,
          rowspan: row._rowspan
        }
      }
    },
    // 表格头部按钮相关事件
    handClick (event, data) {
      const dialogInfo = this.dialogInfo
      switch (event) {
        case 'create':
          this.tableDataCusLoading = true
          let arr=[]
          let arr2=[]
          if (!this.addOrUp) {
            for (let ind2 of this.tableInfo2.data) {
              for (let ind of ind2.basePriceAreaList) {
                // ind.partnerId = this.formDate.partnerId
                // ind.partnerName = this.formDate.partnerName
                // ind.partnerCode = this.formDate.partnerCode
                ind.saleType = this.formDate.saleType
                ind.priceBookId = JSON.parse(localStorage.BasicPriceDate).priceBookId
                ind.tissueId = localStorage.loginTissueId
                ind.tissueName = localStorage.loginTissueName
                if (this.formDate.saleType === 1) {
                  ind.projectId = this.formDate.projectId
                  ind.projectCode = this.formDate.projectCode
                  ind.projectName = this.formDate.projectName
                }
                ind.partnerAddPrice=ind.partnerAddPrice?Number(ind.partnerAddPrice):0
                arr.push(ind)
              }
            }
            this.$api.Customer.batchSaveBasePricePartner({basePricePartnerSaveFormList: arr}).then(res => {//客户
              this.tableDataCusLoading = false
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                this.formDate.partnerId = ''
                this.getInfo()
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            })
          }else{
            for (let ind2 of this.tableInfo2.data) {
              for (let ind of ind2.basePriceAreaList) {
                if (Number(ind.id)) {
                  arr.push({
                    areaAddPrice:ind.areaAddPrice,basePrice:ind.basePrice,id:Number(ind.id),partnerAddPrice:Number(ind.partnerAddPrice),
                    partnerPrice:ind.partnerPrice
                  })
                } else {
                  ind.saleType = this.formDate.saleType
                  ind.priceBookId = JSON.parse(localStorage.BasicPriceDate).priceBookId
                  ind.tissueId = localStorage.loginTissueId
                  ind.tissueName = localStorage.loginTissueName
                  ind.partnerAddPrice=ind.partnerAddPrice?Number(ind.partnerAddPrice):0
                  arr2.push(ind)
                }
              }
            }
            this.$api.Customer.updateBasePricePartnerBatch({basePricePartnerUpdateFormList: arr}).then(res => {//客户
              this.tableDataCusLoading = false
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                this.getInfo()
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            })
            if (arr2.length>0) {
              this.$api.Customer.batchSaveBasePricePartner({basePricePartnerSaveFormList: arr2}).then(res => {//客户
                // this.tableDataCusLoading = false
                if (res.code === 0) {
                  // this.$message({ message: res.msg, type: 'success' })
                  // this.formDate.partnerId = ''
                  this.getInfo()
                } else {
                  this.$message({ message: res.msg, type: 'error' })
                }
              })
            }
          }
          break
        case 'dropDown':
          this.tableDataCusLoading = true
          this.$api.Customer.inEffectBasePricePartnerPage({tissueId:localStorage.loginTissueId}).then(res => {//客户生效价格本
            this.tableDataCusLoading = false
            if (res.code == 0) {
              this.$message({ message: res.msg, type: 'success' })
              if (res.data.list.length>0) {
                for (let inf of res.data.list) {
                  for (let inde of inf.basePricePartnerList) {
                    for (let inde1 of this.tableInfo2.data) {
                      for (let inde2 of inde1.basePriceAreaList) {
                        if (inde.areaId == inde2.areaId && inde.materialId == inde2.materialId && inde.partnerId == inde2.partnerId) {
                          // inde2.childs[0].areaPrice = inde.areaPrice == 0?0:Number(inde.basePrice)+Number(inde.areaAddPrice)
                          // inde2.areaPrice = inde.areaPrice ==0?0:Number(inde.basePrice)+Number(inde.areaAddPrice)
                          inde2.childs[1].partnerAddPrice= inde.partnerAddPrice ==0?0:inde.partnerAddPrice
                          inde2.partnerAddPrice= inde.partnerAddPrice ==0?0:inde.partnerAddPrice
                          inde2.childs[2].partnerPrice= inde.partnerPrice ==0?0:Number(inde2.areaPrice)+Number(inde2.partnerAddPrice)
                          inde2.partnerPrice= inde.partnerPrice ==0?0:Number(inde2.areaPrice)+Number(inde2.partnerAddPrice)
                          if (inde.partnerPrice) {
                            inde2.childs[2].partnerPrice= inde.partnerPrice ==0?0:inde.partnerPrice
                            inde2.partnerPrice= inde.partnerPrice ==0?0:inde.partnerPrice
                            inde2.childs[1].partnerAddPrice= Number(inde2.partnerPrice)-Number(Number(inde.basePrice)+Number(inde.areaAddPrice))
                            inde2.partnerAddPrice= Number(inde2.partnerPrice)-Number(Number(inde.basePrice)+Number(inde.areaAddPrice))
                          }
                        }
                      }
                    }
                  } 
                }
              }
            } else {
              this.$message({ message: res.msg, type: 'error' })
            }
          })
          break
        case 'delete':
          let delDataCus = []
          for (let inde of this.tableInfo2.data) {
            // console.log(inde)
            for (let indes of inde.basePriceAreaList) {
              delDataCus.push(indes.id)
            }
          }
          this.$confirm('确认删除该客户记录吗？', '提示', {
            type: 'warning'
          }).then(() => {
            this.$api.Customer.deleteBasePricePartners({ ids: delDataCus }).then(res => {
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                this.tableInfo2.data =[]
                this.formDate.partnerId = ''
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            })
          })
          break
        case "back":
          this.$router.push('/index/system/BasicPrice')//返回基础价格本
          break;
        case "refresh":
          this.formDate.projectId = ''
          this.formDate.partnerId = ''
          // this.formDate.saleType = ''
          // this.tableInfo2.data = []
          this.getInfo()
          break
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>


// WEBPACK FOOTER //
// src/views/pages/System/BasicPriceAddCus.vue